module.exports = {
  demo: {
    title: "demo",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  index: {
    title: "首页",
    requiredParams: {
      //必填参数
      // id:'课程包的id',
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  loginForH5: {
    //H5登陆页面
    title: "登陆护士加",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  loginForOrder: {
    //接单引导登陆页面
    title: "登陆护士加",
    requiredParams: {
      //必填参数
      orderNo: "订单编号",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  loginForStudio: {
    //工作室引导登陆页面
    title: "登陆护士加",
    requiredParams: {
      //必填参数
      workstationId: "工作室id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  paySuccess: {
    title: "支付成功",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  settlePage: {
    title: "结算页面",
    requiredParams: {
      //必填参数
      orderNo: "订单编号",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  agreementUser: {
    title: "护士加用户协议",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  agreementPrivacy: {
    title: "护士加隐私政策",
    requiredParams: {},
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  agreementStudioMembers: {
    title: "工作室成员协议",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  agreementStudioManager: {
    title: "护士工作室负责人服务协议",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  joinExam: {
    title: "加入考试",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      skillTagId: "技能ID（如果没有就必须传考场号）",
      testingNumber:
        "考场号（如果没有就必须传技能ID）在明确知道考场号的情况下应该直接打开考场页面，这里是消息push用",
    },
    localStorage: {},
    sessionStorage: {},
  },
  examRules: {
    title: "考试须知",
    requiredParams: {
      //必填参数
      testingNumber: "考场号",
    },
    optionalParams: {
      //可选参数
      againFlag: "是否为重新挑战(1:重新挑战, 0:不是,不传默认为0)",
    },
    localStorage: {},
    sessionStorage: {},
  },
  examError: {
    title: "考试异常",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      msg: "错误信息！(默认没有找到对应的考场)",
    },
    localStorage: {},
    sessionStorage: {},
  },
  walletRules: {
    title: "钱包规则",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  withdrawalsRules: {
    title: "提现规则",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  courseDetails: {
    title: "课程详情页",
    requiredParams: {
      //必填参数
      courseId: "课程ID",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  studyData: {
    title: "学习数据",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  articleDetails: {
    title: "资讯详情",
    requiredParams: {
      //必填参数
      id: "文章id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  serviceDetails: {
    title: "推荐服务详情页",
    requiredParams: {
      //必填参数
      id: "服务Id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  orderDetails: {
    title: "订单详情",
    requiredParams: {
      //必填参数
      orderNo: "订单编号",
      orderStatus: "订单状态",
      orderType: "订单类型，1接单，2发单",
      origin: "订单来源，1工作室， 2发现",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  orderTransition: {
    title: "订单详情",
    requiredParams: {
      //必填参数
      orderNo: "订单编号",
      orderType: "订单类型，1接单，2发单",
      origin: "订单来源，1工作室， 2发现",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  findReceivedOrders: {
    title: "订单详情",
    requiredParams: {
      //必填参数
      orderNo: "订单编号",
      orderType: "订单类型，1接单，2发单",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  sendOrder: {
    title: "工作室发单",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  searchStudio: {
    title: "搜索工作室",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  sendOrderSuccess: {
    title: "发单成功",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  applyStudio: {
    title: "申请开设工作室",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      workstationId: "工作室id，有是修改， 没有则是申请",
      review: "实名或基础认证正在审核",
      hasId: "修改工作室，从预览页面，重新进入修改工作室",
    },
    localStorage: {},
    sessionStorage: {},
  },
  previewStudio: {
    title: "预览开设工作室",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      workstationId: "工作室id，有是预览修改，没有则是申请",
    },
    localStorage: {},
    sessionStorage: {},
  },
  applyStudioSuccess: {
    title: "提交申请工作室成功",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      edit: "1=》修改工作室",
    },
    localStorage: {},
    sessionStorage: {},
  },
  exitStudioSuccess: {
    title: "退出工作室",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  studioDetails: {
    title: "工作室详情",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      workstationId:
        "工作室id，如果不传，查询自己的工作室详情，传id,根据id查工作室详情",
    },
    localStorage: {},
    sessionStorage: {},
  },
  previewOrder: {
    title: "预览工作室订单",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },

  studyPlan: {
    title: "学习计划",
    requiredParams: {
      //必填参数
      relationId: "421101498699223040", //关系表id
      planId: "计划id",
      makePlan: "1", // 1:制定计划 2:查看计划
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  studyPlanList: {
    title: "学习计划列表",
    requiredParams: {
      //必填参数
      // relationId: "421101498699223040", //关系表id
      // planId: "计划id",
      // makePlan: "1" // 1:制定计划 2:查看计划
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  joinStudio: {
    title: "申请加入工作室",
    requiredParams: {
      //必填参数
      workstationId: "工作室id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  joinStudioSuccess: {
    title: "申请加入工作室成功",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  authDetails: {
    title: "认证详情",
    requiredParams: {
      //必填参数
      isType: "认证类型(1:实名认证 2:基础认证 3:职业认证), 用于区分oss上传目录",
    },
    optionalParams: {
      //可选参数
      isEdit: "0:未提交,1:审核通过, 2:未通过, 3:审核中",
      formDialog: "从弹窗实名认证进入， 必须传一个标识符， 如 1",
      id: "证书id, 我的认证进入认证详情，必须传证书id",
      isFind:
        "弹窗同时缺少实名认证和基础认证，并且点击实名认证，需要此参数[引导用户同时进行实名认证和基础认证]，用于底部按钮【下一步】直接跳转至基础认证页, 如 true",
      orderId:
        "来自certSpecial页面, 必须传orderId，用于认证完成返回certSpecial页面",
      formFail: "审核不通过，并且点击再次提交时需要用到",
      realName: "实名认证，需要自取模板",
    },
    localStorage: {},
    sessionStorage: {},
  },
  baseAuth: {
    title: "基础认证",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  authMemberDetails: {
    title: "查看成员认证",
    requiredParams: {
      //必填参数
      id: "成员主键Id",
      isType: "认证类型(1:实名认证 2:基础认证 3:职业认证)",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  submitReviewSuccess: {
    title: "提交审核成功",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
      orderId: "需要返回certSpecial页面",
      backUrl: "返回地址",
    },
  },
  topicWrong: {
    title: "错题集",
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  topicStudy: {
    title: "练习题",
    requiredParams: {
      //必填参数
      operateCourseId: "运营课程包id",
      //type:'1运营包下的直接试卷-试题、2课程包下的试卷-试题、3运营包下的原子课-试题、4教研包下的原子课-试题、5运营包下原子课知识点-试题、6教研包下原子课知识点-试题',
    },
    optionalParams: {
      //可选参数
      coursePackageId: "课程包id",
      testPaperNo: "试卷编号",
      atomicCourseId: "原子课id",
      knowledgeId: "知识点Id",

      errorOrCorrect: "1看全部，2只看正确，3只看错误", //查看详情的时候用
      questionId:
        "题目的ID,用来定位到某个题目(不传或没有找到题目ID都是从第一题开始)",
      gobackType: "APP内 左上角返回的方式  gradual:逐级返回 back:直接返回",
    },
    localStorage: {},
    sessionStorage: {},
  },
  topicStudyResult: {
    title: "练习题结果页",
    requiredParams: {
      //必填参数
      operateCourseId: "运营课程包id",
      //type:'1运营包下的直接试卷-试题、2课程包下的试卷-试题、3运营包下的原子课-试题、4教研包下的原子课-试题、5运营包下原子课知识点-试题、6教研包下原子课知识点-试题',
    },
    optionalParams: {
      //可选参数
      // coursePackageId:'type=2必填,type=4必填,type=6必填,运营课程包id',
      // operateCourseId:'type=1必填,type=2必填,type=3必填,type=4必填,type=5必填,type=6必填,运营课程包id',
      // testPaperNo:'type=1必填,type=2必填,试卷编号',
      // atomicCourseId:'type=3必填,type=4必填,type=5必填,type=6必填,原子课id',
      // knowledgeId:'type=5必填,type=6必填,知识点Id'
      coursePackageId: "课程包id",
      testPaperNo: "试卷编号",
      atomicCourseId: "原子课id",
      knowledgeId: "知识点Id",
    },
    localStorage: {},
    sessionStorage: {},
  },
  topicExam: {
    title: "考试详情",
    requiredParams: {
      //必填参数
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id",
      againFlag: "是否为重新挑战(1:重新挑战, 0:不是,不能未空)",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  topicExamResult: {
    title: "考试结果",
    requiredParams: {
      //必填参数
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  topicExamDetails: {
    title: "考试结果详情",
    requiredParams: {
      //必填参数
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id",
    },
    optionalParams: {
      //可选参数
      questionId:
        "题目的ID,用来定位到某个题目(不传或没有找到题目ID都是从第一题开始)",
      errorOrCorrect: "1看全部，2只看正确，3只看错误",
    },
    localStorage: {},
    sessionStorage: {},
  },
  certSpecial: {
    title: "专业认证",
    requiredParams: {
      //必填参数
      orderId: "订单Id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  internetCertificate: {
    title: "我的证书",
    requiredParams: {
      //必填参数
      id: "证书id",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  insurance: {
    title: "我的保险",
    requiredParams: {
      //必填参数
      url: "保险的pdf页面",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },

  // h5分享页面
  shareOrder: {
    title: "详情页", // 订单
    requiredParams: {
      //必填参数
      orderNo: "订单编号",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  shareStudio: {
    title: "工作室详情", // 工作室
    requiredParams: {
      //必填参数
      workstationId: "工作室id",
      sourceUserId: "分享人用户id， 用于分佣",
    },
    optionalParams: {
      //可选参数
    },
    localStorage: {},
    sessionStorage: {},
  },
  shareArticle: {
    title: "文章详情", // 文章详情
    requiredParams: {
      //必填参数
      id: "文章id",
    },
    optionalParams: {
      //可选参数
      sourceUserId: "分享人用户id， 用于分佣",
    },
    localStorage: {},
    sessionStorage: {},
  },
  shareCourse: {
    title: "课程详情", // 课程详情
    requiredParams: {
      //必填参数
      courseId: "课程Id",
    },
    optionalParams: {
      //可选参数
      sourceUserId: "分享人用户id， 用于分佣",
      alipay: "是否开启支付宝支付",
    },
    localStorage: {},
    sessionStorage: {},
  },
  shareCourseSettle: {
    title: "确认订单", // 课程介绍
    requiredParams: {
      //必填参数
      courseId: "课程Id",
    },
    optionalParams: {
      //可选参数
      couponId: "优惠券id",
      sourceUserId: "分享人用户id， 用于分佣",
    },
    localStorage: {},
    sessionStorage: {},
  },
  shareCoupon: {
    title: "卡券", // 课程介绍
    requiredParams: {
      //必填参数
      courseId: "课程Id",
    },
    optionalParams: {
      //可选参数
      sourceUserId: "分享人用户id，[用于返回结算页]",
    },
    localStorage: {},
    sessionStorage: {},
  },
  shareCourseAudition: {
    title: "试听课程", // 课程介绍
    requiredParams: {
      //必填参数
      courseId: "课程Id",
      code: "",
    },
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  nursingEvaluation: {
    title: "护理评估",
    requiredParams: {
      serviceInfoId: "子服务订单ID",
      templateId: "调查表内容的主键",
    },
    optionalParams: {},
    localStorage: {
      nursingEvaluation: "护理记录表单数据（当前页面处于没有网络状态下）",
    },
    sessionStorage: {},
  },
  nursingEvaluationDetails: {
    title: "护理评估详情",
    requiredParams: {
      serviceInfoId: "子服务订单ID",
      //templateId:'调查表内容的主键'
    },
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  visitDetails: {
    title: "客服服务确认详情",
    requiredParams: {
      id: "订单id",
      //templateId:'调查表内容的主键'
    },
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  testAppGuide: {
    title: "抢先体验最新版「护士加」app",
    requiredParams: {},
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  applePayGuide: {
    title: "如何开通苹果支付",
    requiredParams: {},
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  serviceProcess: {
    title: "查看服务流程",
    requiredParams: {
      pdfUrl: "pdf地址",
    },
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  programFail: {
    title: "失败页面",
    requiredParams: {},
    optionalParams: {},
    localStorage: {},
    sessionStorage: {},
  },
  unableToLogin: {
    title: "申请更换手机号", //无法登陆的入口，以后可能会换标题
    requiredParams: {},
    optionalParams: {},
  },
  bindingCard: {
    title: "激活学习卡",
    requiredParams: {},
    optionalParams: {},
  },
  download: {
    title: "下载APP",
    requiredParams: {},
    optionalParams: {},
  },
  realName: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {},
  },
  realNameSuccess: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {},
  },
  realNameError: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {},
  },
  autoLogin: {
    title: "",
    requiredParams: {
      reqKey: "请求key",
    },
    optionalParams: {},
  },
  sendCoupon: {
    title: "优惠券",
    requiredParams: {
      id: "券池id",
    },
    optionalParams: {},
  },
  sharePackGoods: {
    title: "多规格商品",
    requiredParams: {
      id: "多规格id",
    },
    optionalParams: {},
  },
};
